<div class="mt-1">
    <a class="btn btn-outline btn-gray width-full mb-1"
       [href]="url()"
       target="_blank">
        <span class="text-normal-case min-width-0 text-ellipsis" [textContent]="title()"></span>
        <svg ycnIcon class="icon-download ml-1" name="icon-download" role="img"></svg>
    </a>
</div>
